









import { Component, Mixins } from "vue-property-decorator";
import { User } from "../../../../../../domain/user";
import { instanceOfIWizardObjectMultiSelectable } from "../../../../../../domain/format";
import {
  ISingleSelectableAsynchronously,
  ISingleSelectableConditionallyAsynchronously,
  IMultiSelectableAsynchronously,
  IMultiSelectableConditionallyAsynchronously,
} from "../../../../../system/selectors";
import UserListSelectorDialog from "../../../../../user/dialogs/UserListSelectorDialog.vue";
import MultiOrderableUserListSelectorDialog from "../../../../../user/dialogs/MultiOrderableUserListSelectorDialog.vue";
import { IUserListSelectorDialogCondition } from "../../../../../user/dialogs/IUserListSelectorDialogCondition";
import { IMultiOrderableUserListSelectorDialogCondition } from "../../../../../user/dialogs/IMultiOrderableUserListSelectorDialogCondition";
import { UserSelectableContentMixin } from "./mixins";
import WizardContentTextIndicator from "./WizardContentTextIndicator.vue";
import { FatalIndicator } from "./common";

@Component({
  components: {
    UserListSelectorDialog,
    MultiOrderableUserListSelectorDialog,
    WizardContentTextIndicator,
    FatalIndicator,
  }
})
export default class WizardContentUserSelector extends Mixins(UserSelectableContentMixin) {
  get defaultSelectedProfessionCodes(): string[] {
    return this.$configuration.behavior.user.finder.doctorProfessionCodes;
  }

  get defaultDepartmentId(): string {
    return this.defaultSelectedDepartment
      ? this.defaultSelectedDepartment.id
      : null;
  }

  get isSelectable(): boolean {
    return this.isAccessorEnable;
  }

  get isMultiSelectable(): boolean {
    return instanceOfIWizardObjectMultiSelectable(this.content) && this.content.isMultiSelectable;
  }

  get userListSelectorDialog(): ISingleSelectableAsynchronously<User> & ISingleSelectableConditionallyAsynchronously<User, IUserListSelectorDialogCondition> {
    return this.$commonDialogs.user.userListSelector;
  }

  get userListSelectorDialogCondition(): IUserListSelectorDialogCondition {
    return {
      name: "職員",
      departmentId: this.defaultDepartmentId,
      defaultSelectedProfessionCodes: this.defaultSelectedProfessionCodes,
    };
  }

  get multiOrderableUserListSelectorDialog(): IMultiSelectableAsynchronously<User> & IMultiSelectableConditionallyAsynchronously<User, IUserListSelectorDialogCondition> {
    return this.$commonDialogs.user.multiOrderableListSelector;
  }

  get multiOrderableUserListSelectorDialogCondition(): IMultiOrderableUserListSelectorDialogCondition {
    return {
      departmentId: this.defaultDepartmentId,
      isMultiSelectable: true,
      name: null,
      defaultSelectedProfessionCodes: this.defaultSelectedProfessionCodes,
      isMultiSingleSwitchable: false,
    };
  }

  async onClicked(): Promise<void> {
    const result = this.isMultiSelectable
      ? await this.showMultiSelectDialog()
      : await this.showSingleSelectDialog();
    if (result === undefined) { return; }
    this.users = result;
  }

  async showSingleSelectDialog(): Promise<User[]> {
    const result = await this.userListSelectorDialog.selectOptionConditionally(
      this.userListSelectorDialogCondition,
      ((this.users && this.users.length > 0) ? this.users[0] : null)
    );
    if (result === null) { return null; } // クリア
    if (result === undefined) { return undefined; } // キャンセル
    return [result];
  }

  async showMultiSelectDialog(): Promise<User[]> {
    const result = await this.multiOrderableUserListSelectorDialog.selectOptionsConditionally(
      this.multiOrderableUserListSelectorDialogCondition,
      this.users
    );
    return result;
  }
}
